import classes from "./Weather.module.css";
import { Fragment, useContext } from "react";
import BoxTitle from "../../box/title/BoxTitle";

import { LoadingDot } from "../../UI/spinners/LoadingSpinners";

import { baseUrl } from "../../../../SMARTCITY/hardCodeData/DATA";

import { WeatherDataContext } from "../../../hooks/context";
import { useTranslation } from "react-i18next";

const Weather = () => {
  const { WeatherData, loading } = useContext(WeatherDataContext);
  const { t } = useTranslation();

  return (
    <Fragment>
      <BoxTitle
        className={classes.weatherTitle}
        title={t("weather.title")}
        icon="im im-icon-Cloud-Weather"
        infoContext={t("weather.tooltip")}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{
              fontSize: "32px",
              minWidth: "32px",
              color: "black",
              cursor: "pointer",
            }}
          />
        }
      />

      {WeatherData?.length > 0 && (
        <div className={classes.weatherGridContainer}>
          <div className={classes.squareBox}>
            <img
              src={"https://smartcity.patras.gr" + WeatherData[0]?.curr_icon}
              // src={baseUrl + WeatherData[0]?.curr_icon}
              alt="weather_icon_totday"
              width="75px"
            />
            <p className={classes.descriptionContent}>
              {t(`weather.info.conditions.${WeatherData[0]?.curr_description}`)}
            </p>
          </div>
          <div className={classes.squareBox}>
            <p className={classes.tempBox}>
              {WeatherData[0]?.curr_val} <sup>o</sup>C
            </p>
            <p className={classes.descriptionContent}>
              {t("weather.info.today")}
            </p>
          </div>
          <div className={classes.squareBox}>
            <img
              src={"https://smartcity.patras.gr" + WeatherData[0]?.next_icon}
              // src={baseUrl + WeatherData[0]?.next_icon}
              alt="weather_icon_tommorw"
              width="75px"
            />
            <p className={classes.descriptionContent}>
              {t(`weather.info.conditions.${WeatherData[0]?.next_description}`)}
            </p>
          </div>
          <div className={classes.squareBox}>
            <p className={classes.tempBox}>
              {WeatherData[0]?.next_val} <sup>o</sup>C
            </p>
            <p className={classes.descriptionContent}>
              {t("weather.info.tomorrow")}
            </p>
          </div>
        </div>
      )}
      {loading && <LoadingDot />}
      {WeatherData?.length === 0 && (
        <p
          style={{
            fontWeight: "600",
            fontSize: "14px",
            paddingTop: "50px",
            color: "#333",
          }}
        >
          Αδυναμία λήψης δεδομένων λόγω προβλήματος
        </p>
      )}
    </Fragment>
  );
};

export default Weather;
